import { z } from 'zod';

export const USER_APPROVE_STATUS = {
  WAITING: 'WAITING',
  APPROVED: 'APPROVED',
  NOT_APPROVED: 'NOT_APPROVED',
} as const;

export const UserApproveStatusSchema = z.enum([
  USER_APPROVE_STATUS.WAITING,
  USER_APPROVE_STATUS.APPROVED,
  USER_APPROVE_STATUS.NOT_APPROVED,
]);

export type UserApproveStatus = z.infer<typeof UserApproveStatusSchema>;
